module.exports = __webpack_public_path__ + "static/media/school.4b56d3d6.png";